import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { putV2ApiCompanyIdCardsInvoicesRequestIdSendBackToReview } from 'src/client/spendesk-api';

export const useSendCardInvoiceBackToReviewMutation = () => {
  const companyId = useCompanyId();

  return useMutation(
    ['v2', 'sendInvoiceCardBackToReview'],
    async ({ requestId }: { requestId: string }) => {
      const response =
        await putV2ApiCompanyIdCardsInvoicesRequestIdSendBackToReview({
          path: {
            companyId,
            requestId,
          },
        });

      if (!/^2\d{2}$/.test(`${response.statusCode}`)) {
        throw new Error(
          `Failed to send card invoice back to review ${requestId}`,
        );
      }
      return response.body;
    },
    {
      retry: false,
    },
  );
};
